/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LogoMicrosoftIcon16Light } from './LogoMicrosoftIcon16Light';
import { LogoMicrosoftIcon16Regular } from './LogoMicrosoftIcon16Regular';
import { LogoMicrosoftIcon16Solid } from './LogoMicrosoftIcon16Solid';
import { LogoMicrosoftIcon20Light } from './LogoMicrosoftIcon20Light';
import { LogoMicrosoftIcon20Regular } from './LogoMicrosoftIcon20Regular';
import { LogoMicrosoftIcon20Solid } from './LogoMicrosoftIcon20Solid';
import { LogoMicrosoftIcon24Regular } from './LogoMicrosoftIcon24Regular';
import { LogoMicrosoftIcon24Solid } from './LogoMicrosoftIcon24Solid';
import { LogoMicrosoftIcon32Regular } from './LogoMicrosoftIcon32Regular';
import { LogoMicrosoftIcon64Regular } from './LogoMicrosoftIcon64Regular';
var sizes = {
    16: {
        light: LogoMicrosoftIcon16Light,
        regular: LogoMicrosoftIcon16Regular,
        solid: LogoMicrosoftIcon16Solid,
    },
    20: {
        light: LogoMicrosoftIcon20Light,
        regular: LogoMicrosoftIcon20Regular,
        solid: LogoMicrosoftIcon20Solid,
    },
    24: {
        regular: LogoMicrosoftIcon24Regular,
        solid: LogoMicrosoftIcon24Solid,
    },
    32: {
        regular: LogoMicrosoftIcon32Regular,
    },
    64: {
        regular: LogoMicrosoftIcon64Regular,
    },
};
export var LogoMicrosoftIcon = forwardRef('LogoMicrosoftIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
